import React from "react";

import { Box, Link, Icon, IconButton, Divider, Card, Typography } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import LinkIcon from '@mui/icons-material/Link';
import SolutionIcon from '@mui/icons-material/KeyboardDoubleArrowDown';

// common
import { dic } from "@common/text_defs";
// component

const SolutionSection = () => {

  const itemList = [
    {
      name: `対策１：クラウド上でのデータの一元管理`,
      text1: `WebページからExcelをアップロードするだけでデータの共有が可能`,
      text2: `ワークフローでの進捗管理が可能`,
    },
    {
      name: `対策２：バージョンや変更履歴をシステム側で管理`,
      text1: `システム側でバージョン管理をすることにより、作業者のミスの低減が期待できる`,
      text2: `変更履歴をDBに残すことにより、問題発生時の検証が可能`,
    },
    {
      name: `対策３：Excel、PDFデータをツールで抽出してDBに格納`,
      text1: `データベース上のデータは他システムとの連携が可能`,
      text2: `ERP、CRM等の他システム連携、データ・アナリティクスやマシンラーニングでのデータ活用、BIツールでのデータの可視化が実現可能`,
    },
    {
      name: `対策４：現行業務で使用されているExcel、PDFをそのまま利用`,
      text1: `Excel、PDF上のデータやロジックをそのまま活用ことにより、システム開発のコストダウンが期待できる`,
      text2: `作業者の運用において、Excelのダウンロード・アップロード操作以外の大きな変更は発生しないため、教育コストの低減も期待できる`,
    },
  ];

  return (
    <Box component="section" className="section bg-light-gray" id="works" sx={{ pb: 0 }}>
      <Box component="div" className="container">
        <Box sx={{ mb: 2, }}>
          <SolutionIcon color="primary" sx={{ display: 'block', mx: 'auto', fontSize: '60px' }} />
        </Box>
        <Grid container spacing={3}>
          {itemList.map((pane, index) => (
            <Grid md={3} sm={6} xs={12} key={index}>
              <Card className="relative card" key={index} sx={{ height: "100% !important", display: "flex", flexDirection: "column", }}>
                <Box sx={{ px: 4, pt: 4 }}>
                  <h5 className="m-0 text-16 font-bold">{pane.name}</h5>
                  <p className="mb-4">{pane.text1}</p>
                  <p className="mb-4">{pane.text2}</p>
                </Box>
                <Box sx={{ flexGrow: 1 }}></Box>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box >
  );
};

export { SolutionSection };
